module.exports = __webpack_public_path__ + "static/media/om_eyeshape_almond_lightbrown.ef585389.png";